let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("6kSRw")).then(() => parcelRequire('9NBPE'));